import React, { ComponentProps } from 'react';
import { BodyText } from '@chargify/custom-ui-components';

import InputSocket from '../InputSocket';
import HostedField from '../HostedField';

import { Container, Socket } from './CardExpiration.styles';

import { MONTH_FIELD_WIDTH, YEAR_FIELD_WITH } from './constants';
import { CreditCardPCIFields } from '../../types';

type CardExpirationProps = {
  /**
   * Month HTML element identifier
   */
  monthHtmlElementId?: string;
  /**
   * Year HTML element identifier
   */
  yearHtmlElementId?: string;
} & ComponentProps<typeof HostedField>;
const CardExpiration = ({
  label,
  hasError,
  required,
  monthHtmlElementId = CreditCardPCIFields.ExpirationMonth,
  yearHtmlElementId = CreditCardPCIFields.ExpirationYear,
}: CardExpirationProps) => (
  <HostedField label={label} hasError={hasError} required={required}>
    <Container>
      <InputSocket hasError={hasError}>
        <Socket
          width={MONTH_FIELD_WIDTH}
          id={monthHtmlElementId}
          data-testid={monthHtmlElementId}
        />
        <BodyText variant="body2">/</BodyText>
        <Socket
          width={YEAR_FIELD_WITH}
          id={yearHtmlElementId}
          data-testid={yearHtmlElementId}
        />
      </InputSocket>
    </Container>
  </HostedField>
);

export default CardExpiration;
